import { EntitlementsProject, PRODUCT_IDS } from '@adsk/alloy-provider';

import {
  DEFAULT_LIMIT,
  DEFAULT_SORT_FIELD,
  SORT_DIRECTION,
} from '../constants';
import { LegacyProducts } from '../models';
import { formatDateToISOString } from '../utils/dateFormat';

export type PaginationResponse = {
  limit: number;
  nextUrl?: string;
  previousUrl?: string;
  offset: number;
  totalResults: number;
};

export type DefaultPaginatedResponse<T> = {
  results: T[];
  pagination: PaginationResponse;
};

export const EntitlementsProducts = [
  PRODUCT_IDS.DESIGN_COLLABORATION,
  PRODUCT_IDS.DOCS,
  PRODUCT_IDS.INSIGHT,
  PRODUCT_IDS.MODEL_COORDINATION,
  PRODUCT_IDS.TAKEOFF,
  PRODUCT_IDS.PROJECT_ADMINISTRATION,
  ...Object.values(LegacyProducts),
];

export const EntitlementsFields = [
  'name',
  'jobNumber',
  'accountName',
  'accountImageUrl',
  'createdAt',
  'platform',
  'classification',
  'accountId',
  'addressLine1',
  'defaultUrl',
  'products',
  'mfaBlocked',
];

type FiltersType = {
  name?: string;
  jobNumber?: string;
  sortKey: keyof EntitlementsProject;
  sortDirection: SORT_DIRECTION;
  classification?: string[];
  offset?: number;
  projectType?: string;
  createdAtRange?: string;
  accountIds?: string;
  orFilters?: string;
};

export const createEntitlementsFilterParams = ({
  name = '',
  jobNumber,
  sortKey = DEFAULT_SORT_FIELD,
  sortDirection = SORT_DIRECTION.ASCENDING,
  classification = [],
  offset = 0,
  projectType,
  createdAtRange,
  accountIds,
  orFilters,
}: FiltersType) => {
  if (createdAtRange) {
    const [from, to] = createdAtRange.split('..');
    const formattedFrom = formatDateToISOString(from);
    const formattedTo = formatDateToISOString(to);
    createdAtRange = `${formattedFrom}..${formattedTo}`;
  }

  return new URLSearchParams({
    limit: DEFAULT_LIMIT.toString(),
    fields: EntitlementsFields.toString(),
    'filter[name]': name,
    'filter[classification]': classification.toString(),
    'filter[products]': EntitlementsProducts.toString(),
    ...(jobNumber && { 'filter[jobNumber]': jobNumber }),
    ...(projectType && { 'filter[platform]': projectType }),
    ...(accountIds && { 'filter[accountIds]': accountIds }),
    ...(createdAtRange && {
      'filter[createdAt]': createdAtRange,
    }),
    sort: `${sortKey} ${sortDirection}`,
    offset: offset.toString(),
    ...(orFilters && { orFilters }),
  }).toString();
};
